import { render } from "./HeroSection.vue?vue&type=template&id=1529e65c"
const script = {}

import "./HeroSection.vue?vue&type=style&index=0&id=1529e65c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__